/**
 * English (GBP) mock schedules for the scheduled-transactions use case.
 * A schedule with both source and destination accounts is a schedule pair,
 * rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_EN = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 1240,
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		displayAccount: 'Royal Bank',
		displayFreq: 'Monthly',
		description: 'Rewards Card direct debit',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 1100,
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		displayAccount: 'Royal Bank',
		displayFreq: 'Monthly',
		description: 'Mortgage',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 500,
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		displayAccount: 'Royal Bank',
		displayFreq: 'Monthly',
		description: 'ISA top-up',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 2400,
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		displayAccount: 'Royal Bank',
		displayFreq: 'Monthly',
		description: 'Salary',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 500,
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		displayAccount: 'Royal Bank',
		displaySourceAccount: 'Royal Bank',
		displayDestAccount: 'Savings',
		displayFreq: 'Monthly',
		description: 'To savings',
		pairedType: 'Transfer',
		pairedCurrencySymbol: '\u00A3',
		pairedCurrencyDecimalPlaces: 2,
	},
];
